angular
  .module('affiliateCompanyAdd')
  .component('affiliateCompanyAdd', {
    template: require('./affiliate-company-add.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function AffiliateCompanyAddViewController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $rootScope.mainmenu = 'affiliate';
        $rootScope.menu = 'affiliateCompany';
        const APIURL = envService.read('apiUrl'); // eslint-disable-line
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        this.affiliate = { NAME: '', EMAIL_SUFFIX: '', DISCOUNT_PERCENT: 0 };

        this.submit = () => {
          if (!this.affiliate.NAME || this.affiliate.NAME.length < 1) {
            alert($translate.instant('제휴사 이름을 입력해주세요.'));
            return;
          }
          if (!this.affiliate.EMAIL_SUFFIX || this.affiliate.EMAIL_SUFFIX.length < 1) {
            alert($translate.instant('제휴사 이메일을 입력해주세요.'));
            return;
          }
          if (!this.affiliate.EMAIL_SUFFIX.startsWith('@')) {
            alert($translate.instant('이메일 도메인은 @로 시작되어야 합니다.'));
            return;
          }
          if (!this.affiliate.DISCOUNT_PERCENT || this.affiliate.DISCOUNT_PERCENT.length < 1 || this.affiliate.DISCOUNT_PERCENT < 1) {
            alert($translate.instant('제휴사 할인적용률을 입력해주세요.'));
            return;
          }
          $resource(`${APIURL}/admin/affiliate`).save(this.affiliate).$promise
            .then(() => {
              $location.path('/affiliate/company');
            })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/affiliate-company-add/affiliate-company-add.component.js